import { Button } from '@ui-library/button';
import styled from 'styled-components';

export const CreateNewAccount = styled(Button)`
  width: 100%;
`;
